<template>
    <tr v-if="action && action.key !== 'clear' && action.key !== 'add_name'">
        <td colspan="2">
            <template v-if="action.key === 'change' || action.key === 'add_to_current' || action.key === 'remove_from_current'">
                <FormGroup :label="$t('labels.new_value')">
                    <Input :type="type" v-model="local.value" v-if="type === 'text' || type === 'number'" />
                    <InputTextArea :model-value="local.value ?? ''" @input="local.value = $event" v-else-if="type === 'textarea'" />
                    <AppCheckbox v-model="local.value" v-else-if="type === 'checkbox'" />
                    <Tags v-model="local.value" v-else-if="type === 'tags'" />
                    <AppAutoComplete
                        v-else-if="type === 'category_autocomplete'"
                        @update:model-value="local.value = $event"
                        :model-value="local.value?.uuid"
                        :selected-value="local.value?.name"
                        :url="`/projects/${$route.params.projectUuid}/pim/channels/${$route.params.integrationUuid}/categories`"
                    />
                    <MultiAutoComplete
                        v-else-if="type === 'multi_select'"
                        @update:model-value="local.value = $event"
                        :model-value="local.value ?? []"
                        :query-params="{
                            orders: [{column: 'name', dir: 'asc'}],
                        }"
                        url="/integration-product-tags"
                    />
                </FormGroup>
            </template>

            <template v-else-if="action.key === 'add'">
                <div class="row">
                    <div class="col-lg-6">
                        <FormGroup :label="$t('labels.placing')">
                            <AppSelect
                                option-key="key"
                                option-value="value"
                                :options="addSelectOptions"
                                :model-value="local.add_option?.key"
                                :selected-value="local.add_option?.value"
                                @update:model-value="val => updateField('add_option', val)"
                            />
                        </FormGroup>
                    </div>
                    <div class="col-lg-6">
                        <FormGroup :label="$t('labels.value')">
                            <Input :type="type" :disabled="!local.add_option" v-model="local.value" />
                        </FormGroup>
                    </div>
                </div>
            </template>

            <template v-else-if="action.key === 'replace'">
                <div class="row">
                    <div class="col-lg-4">
                        <FormGroup :label="$t('labels.coincidence')">
                            <AppSelect
                                option-key="key"
                                option-value="value"
                                :options="replaceSelectOptions"
                                :model-value="local.replace_option?.key"
                                :selected-value="local.replace_option?.value"
                                @update:model-value="val => updateField('replace_option', val)"
                            />
                        </FormGroup>
                    </div>
                    <div class="col-lg-4">
                        <FormGroup :label="$t('labels.change_from')">
                            <Input :type="type" :disabled="!local.replace_option" v-model="local.from" />
                        </FormGroup>
                    </div>
                    <div class="col-lg-4">
                        <FormGroup :label="$t('labels.change_to')">
                            <Input :type="type" :disabled="!local.replace_option" v-model="local.to" />
                        </FormGroup>
                    </div>
                </div>
            </template>
        </td>
    </tr>
</template>
<script>
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../../components/new/form/Input.vue';
import AppSelect from '../../../../../components/new/form/select/AppSelect.vue';
import AppCheckbox from '../../../../../components/new/form/checkbox/AppCheckbox.vue';
import InputTextArea from '../../../../../components/new/form/InputTextArea.vue';
import Tags from '../../../../../components/new/form/Tags.vue';
import AppAutoComplete from '../../../../../components/new/form/autocomplete/AppAutoComplete.vue';
import MultiAutoComplete from '../../../../../components/new/form/autocomplete/MultiAutoComplete.vue';

export default {
    name: 'FieldActionEditor',
    components: {
        FormGroup, Input, AppSelect, AppCheckbox, InputTextArea, Tags, AppAutoComplete, MultiAutoComplete
    },
    props: {
        action: {
            type: Object,
            default: null
        },
        modelValue: {
            type: Object,
            default: null
        },
        type: {
            type: String,
            default: 'text'
        },
        addSelectOptions: {
            type: Array,
            default: () => []
        },
        replaceSelectOptions: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        local: {
            get() {
                return this.modelValue || {};
            },
            set(val) {
                this.$emit('update:modelValue', val);
            }
        }
    },
    methods: {
        updateField(key, val) {
            const next = { ...(this.modelValue || {}) };
            next[key] = val;
            this.$emit('update:modelValue', next);
        }
    }
};
</script>